module.exports = __webpack_public_path__ + "static/media/expert.89a50e44.png";